export const ROUTE_WORKER_PREFIX = '/w';
export const ROUTE_EMPLOYER_PREFIX = '/e';
export const ROUTE_ADMIN_PREFIX = '/a';

export const getRoutePrefix = (role) => {
  if (role === 'isWorker') return ROUTE_WORKER_PREFIX;
  if (role === 'isEmployer') return ROUTE_EMPLOYER_PREFIX;
  return '';
};
